module.exports = __webpack_public_path__ + "static/headshot-mitchell-grenier.a3b691b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-mitchell-grenier.jpg
// module id = 134
// module chunks = 35783957827783 152909308826437